import { Routes, Route } from "react-router-dom";

import "./App.css";
import MainPage from "./pages/Main";
import PreviewFormat from "./components/PreviewFormat/PreviewFormat";
import SoundplusLogo from "./components/UI/SoundplusLogo/index";
import { Container } from "@mui/material";
import { FiltersProvider } from "./Context/FiltersContext";

const App = () => {
  return (
    <div className="App">
      <Container maxWidth="xl">
        <FiltersProvider>
          <Routes>
            <Route path="/" element={<SoundplusLogo />} />
          </Routes>
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/preview" element={<PreviewFormat />} />
          </Routes>
        </FiltersProvider>
      </Container>
    </div>
  );
}

export default App;
